import { defaultFilterQuery } from './actions';
import { shouldNotClearDashboardStateOnRouteChange } from '../../common/services/checkRouteChangesUtils';

const defaultState = {
  viewMode: 'REGULAR',
  filterStarted: true,
  chargers: [],
  mapChargers: {
    areLoaded: false,
    areLoading: false,
    loadedCount: 0,
    totalCount: 1,
  },
  filterQuery: defaultFilterQuery,
  chargerModalData: null,
  mapOptions: {
    center: { lat: 40.730610, lng: -73.935242 },
    zoom: 11,
  },
};

function dashboard(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'HISTORY_LOCATION_CHANGE': {
      const { previousPathname } = action;
      const { pathname } = action;

      if (shouldNotClearDashboardStateOnRouteChange(previousPathname, pathname)) {
        return state;
      }

      return { ...defaultState };
    }
    case 'SET_VIEW_MODE':
      return { ...state, viewMode: action.mode };
    case 'OPEN_CHARGER_MODAL':
      return { ...state, chargerModalData: action.data };
    case 'SET_FILTERED_CHARGERS':
      return { ...state, chargers: action.chargers, filteredChargers: action.chargers };
    case 'SET_AUTOSCALE':
      return { ...state, filterStarted: true };
    case 'SET_AUTOSCALE_OFF':
      return { ...state, filterStarted: false };
    case 'SET_FILTER':
      return { ...state, filter: action.filter };
    case 'SET_DASHBOARD_FILTER':
      return { ...state, filterQuery: action.query };
    case 'SET_MAP_CHARGERS_PROPS':
      return { ...state, mapChargers: { ...state.mapChargers, ...action.payload } };
    default:
      return state;
  }
}

export default dashboard;
